import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";

export default function Faq({ faqs, testId = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={testId}>
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
          <AccordionTrigger className="text-left font-display text-lg">{f.q}</AccordionTrigger>
          <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
